import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import ReactGravatar from 'react-gravatar';

import colors from '../utilities/colors';
import spacings from "../utilities/spacings";
import Button from "../common/Button";

const ProfileWrapper = styled.div`
  border: 1px solid ${colors.lightGrey};
  padding: ${spacings.s};
  margin-bottom: ${spacings.m};
  
  .profile {
    position: relative;
  }
  
  .avatar {
    border-radius: 100%;
    background: ${colors.lightGrey};
    height: 32px;
    width: 32px;
    margin-right: 10px;
  }
  
  .logged-as {
    font-size: 12px;
  }
  
  .user-name {
    color: ${colors.primary};
    font-size: 14px;
    font-weight: bold;
  }
  
  .btn-link {
    position: absolute;
    top: -10px; right: -10px;
  }
  
  p {
    font-size: 13px;
  }
`;

const Profile = props => {
    return (
        <div>
            <ProfileWrapper>
                <Button
                    label={'Make a Donation'}
                    href={'https://give.seo-usa.org/give/280843/#!/donation/checkout'}
                    tag={'a'}
                    class={'btn-primary btn-block u-margin-bottom-xs'}
                />

                <Button
                    href={'https://www.seo-usa.org/wp-content/uploads/2020/05/2020-Stay-at-Home-Awards-Dinner-Journal-1.pdf'}
                    label={'View the Dinner Journal'}
                    tag={'a'}
                    class={'btn-secondary btn-block u-margin-top-xs'}
                    onClick={() => {
                        props.toggleModeration(true);
                    }}
                />

            </ProfileWrapper>
            <ProfileWrapper>
                <div className="profile u-flex">
                    <div>
                        <ReactGravatar email={props.user.email ? props.user.email : 'Anonymous'} className="avatar"/>
                    </div>
                    <div>
                        <div className={'logged-as'}>You are logged in as:</div>
                        <div className={'user-name'}>{props.user.email ? props.user.email : 'Guest'}</div>
                    </div>
                    <Button label={'Logout'} onClick={() => props.logout()} tag={'button'} class={'btn-link'}/>
                </div>
            </ProfileWrapper>
        </div>
    );
};

Profile.propTypes = {
    user_id: PropTypes.string,
    name: PropTypes.string,
    gravatar: PropTypes.string,
    location: PropTypes.string
};

export default Profile;
